import {
    GoingUtils,
    AssertUtils
} from "goingutils";
import WinUtils from "../../winUtils";

function _getDisplay(flag) {
    if (flag || AssertUtils.isFunction(flag)) {
        return "display:block;";
    } else {
        return "display:none;";
    }
}

//根据类型获取html字符串
function _getHtmlsByItem({
    id,
    disabled,
    label,
    type,
    name
}, btnId, flag) {
    if (!AssertUtils.isNotEmpty(type) || type === "button") {
        return `<div btnid="go_form_continueBtn" id="${btnId + "_" + id}" class="go-btn-simple ${disabled?'disabled':''} no-padding primary ${flag === 'left' ? 'pull-left' : 'pull-right'}"  style="top:1px;">${label}</div>`;
    }

    if (type === "radio") {
        return `<label class="ivu-radio-wrapper ivu-radio-group-item ivu-radio-default" style="margin-left: 10px;position:relative;top:-3px;"  id="${btnId+'_'+id}" >
                    <span class="ivu-radio"><span class="ivu-radio-inner"></span> 
                    <input type="radio" class="ivu-radio-input" name="${name}"></span><span style="color:#FFF">${label}</span>
               </label>`;
    }

    return "";
}

/**
 * 加载用户定义的按钮
 * @param options
 * @param btnId
 * @private
 */
function __addCustomerBtns(btnAry, btnId, flag) {
    let htmls = [];
    if (AssertUtils.isNotNull(btnAry) && AssertUtils.isArray(btnAry)) {
        btnAry.forEach(function (item) {
            htmls.push(_getHtmlsByItem(item, btnId, flag));
        });
    }
    return htmls.join("");
}



/**
 * 添加用户自定义按钮的事件
 * @param options
 * @param winId
 * @param btnId
 * @private
 */
function __addCustomerBtnsEvent(btnAry, btnId) {
    btnAry.forEach(function (item) {
        if(item.type==="button"){
            _addButtonEvnet(item,btnId);
        }
        if(item.type==="radio"){
            _addRadioButtonEvnet(item,btnId);
        }
    });
}
//添加按钮的事件
function _addButtonEvnet({
    id,
    label,
    disabled,
    type,
    name,
    fun
}, btnId) {

    $(`#${btnId+'_'+id}`).click(function () {
        if($(`#${btnId+'_'+id}`).hasClass("disabled")){
            return void(0);
        }

        if (AssertUtils.isNotNull(fun) && AssertUtils.isFunction(fun)) {
            fun();
        }
    });
}
//添加radio按钮的事件
function _addRadioButtonEvnet({
    id,
      disabled,
    label,
    type,
    name,
    fun
}, btnId) {

    $(`#${btnId+'_'+id}`).click(function () {
        if($(`#${btnId+'_'+id}`).hasClass("disabled")){
            return void(0);
        }
        let radioVal = false;
        //切换选中状态
        if($(this).find(".ivu-radio").hasClass("ivu-radio-checked")){
            radioVal=true;
            $(this).find(".ivu-radio").removeClass("ivu-radio-checked");
        }else{
            radioVal=false;
            $(this).find(".ivu-radio").addClass("ivu-radio-checked");
        }

        if(AssertUtils.isNotNull(fun)&&AssertUtils.isFunction(fun)){
            fun(radioVal);
        }
        //阻止事件冒泡
        return false;
    });
}

function __addSystemBtnsEvent({
        btnId,
        winUuId,
        continueBtn,
        confirmBtn,
        closeWinFun,
        dialogWinId
    }

) {

    //点击取消按钮
    $("#" + btnId + "_cancel").click(function () {
        WinUtils.closeParentCurWin(true,winUuId);
        if (AssertUtils.isNotNull(closeWinFun) && AssertUtils.isFunction(closeWinFun)) {
            closeWinFun();
        }
    });
    //点击继续添加按钮
    continueBtn!=null&&$("#" + btnId + "_continue").click(function () {
        continueBtn(winUuId, () => {
            WinUtils.closeParentCurWin(false,winUuId);
            if (AssertUtils.isNotNull(closeWinFun) && AssertUtils.isFunction(closeWinFun)) {
                closeWinFun();
            }
        });
    });
    //点击确定按钮
    confirmBtn!=null&&$("#" + btnId + "_confirm").click(function () {
        confirmBtn(winUuId, () => {
            WinUtils.closeParentCurWin(true,winUuId);
            if (AssertUtils.isNotNull(closeWinFun) && AssertUtils.isFunction(closeWinFun)) {
                closeWinFun();
            }
        });
    });
}

export function _initWinFooterBar(options, dialogWinId,winUuId) {
    let btnId = GoingUtils.getUUid(12);
    let winId = "layui-layer" + dialogWinId;

    let {
        continueBtn,
        confirmBtn,
    } = options;
    if (options.showBottomBar) {
        let winObj = $("#" + winId);
        let ofsetHeight = winObj.get(0).offsetHeight - 40;
        let barWidth = parseFloat(winObj.css("width"));
        var html = `<div class="dialog-bt-bar " id="${btnId}" style="position: absolute;top:${ofsetHeight}px;width:${barWidth}px">
                  <div class="go-tool-bar clearfix" style="min-height: 37px;padding-top: 5px;box-sizing: border-box;">
                     <div class="pull-left">
                        ${__addCustomerBtns(options.leftBtns, btnId, 'left')}
                     </div>
                     <div class="pull-right">  
                           <div btnid="go_form_confirmBtn"  id="${btnId}_confirm" class="pull-right go-btn-simple no-padding primary _confirmBtn"  style="top:1px;${_getDisplay(confirmBtn)}">${options["confirmLabel"]||'确定'}</div>
                             <div btnid="go_form_continueBtn" id="${btnId}_continue" class="pull-right go-btn-simple no-padding primary _continueBtn"  style="top:1px;${_getDisplay(continueBtn)}">${'继续添加'}</div> 
                             <div btnid="go_form_cancelBtn" id="${btnId}_cancel"  class="pull-right go-btn-simple no-padding gray _cancelBtn" style="top:1px;">${options["cancelLabel"]||'取消'}</div>
                         ${__addCustomerBtns(options.rightBtns, btnId, 'right')}
                      </div>
                  </div> 
            </div>`;
        $(html).appendTo("#" + winId);
    }
    //定义自定义按钮的事件
    if(AssertUtils.isNotEmpty(options.leftBtns)&&AssertUtils.isArray(options.leftBtns)){
        __addCustomerBtnsEvent(options.leftBtns,btnId);
    }

    if(AssertUtils.isNotEmpty(options.rightBtns)&&AssertUtils.isArray(options.rightBtns)){
        __addCustomerBtnsEvent(options.rightBtns,btnId);
    }

    //定义系统按钮事件
    __addSystemBtnsEvent({
        btnId,
        winUuId,
        continueBtn,
        confirmBtn,
        closeWinFun: options.closeWin,
        dialogWinId
    });
}



// WEBPACK FOOTER //
// ./goingsrc/jsCom/utils/bottomBarUtils.js